// models
import type { ReqUserList } from '../models/user.model';

/**
 * User 관련 Query Keys
 *
 * @description
 * 사용자 관련 query-key들을 관리합니다.
 */
export const userKeys = {
  /** ALL */
  USER_ALL: ['user'],

  /** 관리자 페이지 조회 */
  GET_USER_LIST: (query: ReqUserList) => ['user', 'getUserList', JSON.stringify(query)],

  /** 관리자 상세 조회 */
  GET_USER_DETAIL: (userId: string) => ['user', 'getUserDetail', userId]
};
